import React from "react";
import FormatDateTime from "../../../utils/formatDateTime";

const RegimeDataTable = ({ regimeData }) => {
  // Function to convert "rg" and "bb" values

  
  const convertSignal = (signal) => {
    return signal.replace(/r/g, "-1").replace(/g/g, "1").replace(/b/g, "0");
  };

  // Function to generate table rows from array data
  const generateRows = (dataArray) => {
    return dataArray.map((item, index) => (
      <tr
        key={index}
        className="bg-black z-0 border-b last-of-type:border-b-0 border-gray-900 font-medium text-white hover:bg-black/90"
      >
        {Object.keys(item).map((key, idx) => (
          <td
            key={idx}
            className={`${item[key] == "CE" ? "bg-emerald-700" : item[key] == "PE" ? "bg-rose-700" : "" } px-4 py-2 border-r last-of-type:border-r-0 border-gray-900`}
          >
            {key === "last_updated"
              ? FormatDateTime(item[key]) // Format last_updated data
              : key === "regime_signal"
              ? convertSignal(item[key]) // Convert "rg" and "bb"
              : item[key]}
          </td>
        ))}
      </tr>
    ));
  };

  // Function to generate tables from array data
  const generateTables = (dataObject) => {
    return Object.keys(dataObject).map((key, index) => {
      if (key === "message") return null; // Ignore 'message' field
      return (
        <div
          key={index}
          className={`z-0 w-full h-full  animate-reveal transition-all duration-500 ease-in ${
            key === "regime_signal"
              ? " row-span-1 "
              : index === 2
              ? " row-span-3"
              : index === 3
              ? " row-span-3"
              : index === 4
              ? " row-span-3"
              : "  row-span-2"
          }`}
        >
          <h2 className="text-white text-lg font-semibold text uppercase mb-3">
            {key}
          </h2>
          {dataObject[key].length > 0 ? (
            <table className="bg-black border border-gray-700 text-sm w-full relative z-0">
              <thead className="bg-[#0F0F0F] text-sm text-left">
                <tr className="text-white border-b border-gray-800">
                  {Object.keys(dataObject[key][0]).map((header, idx) => (
                    <th
                      key={idx}
                      className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold"
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>{generateRows(dataObject[key])}</tbody>
            </table>
          ) : (
            <h3 className="flex items-center  text-gray-300 text-md font-medium text uppercase">
              Data for {key} Not Present
            </h3>
          )}
        </div>
      );
    });
  };

  return (
    <div className="grid grid-cols-2 grid-flow-row-dense h-[calc(100vh-180px)] gap-x-6 gap-y-4  overflow-y-auto  w-full  px-6">
      {generateTables(regimeData)}
    </div>
  );
};

export default RegimeDataTable;
